import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import FormInputWithCounter from '../../../../../components/FormInputWithCounter';

interface Props {
  open: boolean;
  onClose: () => void;
  totalCount: number;
  handleTreatOrder: (selectedCount: number, type: string) => void;
  type: string;
}
function GiftModal({
  open,
  onClose,
  totalCount,
  handleTreatOrder,
  type,
}: Props) {
  const { t } = useTranslation('pos');

  const [count, setCount] = useState(1);

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    setCount(1);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={
        type === 'treat'
          ? t('orderModal.giftModal.title')
          : t('orderModal.giftModal.removeTitle')
      }
      positiveAction={t('orderModal.giftModal.confirm')}
      onPositiveClick={() => {
        handleTreatOrder(count, type);
        handleClose();
      }}
      negativeAction={t('orderModal.giftModal.cancel')}
      onNegativeClick={handleClose}
    >
      <FormInputWithCounter
        onIncrease={() => count !== totalCount && setCount(count + 1)}
        onDecrease={() => {
          if (count > 1) {
            setCount(count - 1);
          }
        }}
        value={count}
        onChange={(event: any) =>
          setCount(
            parseInt(
              Number(event.target.value) < 1 ? '1' : event.target.value,
              10,
            ),
          )
        }
        disableUnderline
      />
    </Modal>
  );
}

export default GiftModal;
